export const LaunchIcon = ({ size = 20, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4 3H21v5.7l-2.1-2.2-7.5 7.5-1.4-1.4 7.5-7.5L15.4 3ZM5 21h14c1.1 0 2-.9 2-2v-5h-2v5H5v-5H3v5c0 1.1.9 2 2 2Z"
      fill={color}
      fillOpacity=".8"
    />
  </svg>
);

export const DownloadIcon = ({ size = 20, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3v8h3l-4 4-4-4h3V3h2ZM3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5h-2v5H5v-5H3v5Z"
      fill={color}
    />
  </svg>
);

export const LinkIcon = ({ size = 20, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m21.4 5.4-2.8-2.8c-.8-.8-2-.8-2.8 0l-2.9 2.9 1.4 1.4L17.2 4 20 6.8l-7.4 7.4-1.4-1.4-1.4 1.4 1.4 1.4c.8.8 2 .8 2.8 0l7.4-7.4c.8-.7.8-2 0-2.8Z"
      fill={color}
    />
    <path
      d="m2.6 18.6 2.8 2.8c.8.8 2 .8 2.8 0l2.9-2.9-1.4-1.4L6.8 20 4 17.2l7.5-7.5 1.4 1.4 1.4-1.4-1.4-1.4c-.8-.8-2-.8-2.8 0l-7.5 7.5c-.8.8-.8 2 0 2.8Z"
      fill={color}
    />
  </svg>
);

export const FileIcon = ({ size = 20, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 20V8.5c0-.5-.2-1-.6-1.4L15 2.6c-.3-.4-.8-.6-1.4-.6H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2ZM13 4v5h5v11H6V4h7Z"
      fill={color}
    />
  </svg>
);
